import BannerComp from "../../components/BannerComp";
import FeatureCard from "../../components/FeatureCard";
import FeatureFlow from "../../components/FeatureFlow";
import FeatureImageContent from "../../components/FeatureImageContent";
import ImageTextSection from "../../components/ImageTextSection";
import NumbersFlow from "../../components/NumbersFlow";
import Seo from "../../components/Seo";
import {
  collectionSteps,
  featuresCardData,
  stepper,
} from "../../data/toxicology";
import { createBreadcrumbSchema, createWebPageSchema } from "../../lib/seo";
import section1Image from "./toxicology_section1.webp";
import section2Image from "./toxicology_section2.webp";
import section3Image from "./toxicology_section3.webp";

const seo = {
  title: "MITSI Reliable Lab Solutions | MIT4Doctors",
  description:
    "Transform your practice with a fully managed, physician-owned toxicology lab. Get reimbursements, improve patient care, and control testing with our support.",
  schema: [
    createWebPageSchema({
      path: "/services/toxicology-laboratory-solutions",
      title: "MITSI Reliable Lab Solutions",
      description:
        "At MITS, transform your practice with a fully managed, physician-owned toxicology lab. Get reimbursements, improve patient care, and control testing. We support you every step of the way.",
    }),
    createBreadcrumbSchema(
      "/services/toxicology-laboratory-solutions",
      "MITSI Reliable Lab Solutions",
    ),
  ],
};

export default function ToxicologyLaboratorySolutions() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/services/toxicology-laboratory-solutions"
        schema={seo.schema}
      />
      <BannerComp
        heading="MITSI Reliable Lab Solutions"
        paragraph="At MITS, transform your practice with a fully managed, physician-owned toxicology lab. Get reimbursements, improve patient care, and control testing. We support you every step of the way."
        centered
        BannerBgImg="/img/banners/toxicology_hero.webp"
      />

      <ImageTextSection
        image={section1Image}
        imageAlt="What We Offer"
        imagePosition="left"
        title="What We Offer"
        highlightWords="Offer"
        icon={true}
        subSections={[
          {
            heading: "Toxicology Lab Startup & Validation",
            listItems: [
              "Thorough assistance in establishing a CLIA-certified toxicology laboratory.",
              "Expert navigation of regulatory requirements, including CLIA, CAP, and COLA guidelines.",
              "Fully managed processes, from documentation to method validation.",
            ],
          },
          {
            heading: "Custom Solutions for Your Practice",
            listItems: [
              "Fully Equipped Lab Spaces: Move into ready-to-use spaces designed for efficiency.",
              "Regulatory Compliance: Labs follow federal, state, and local regulations.",
              "Trained Staff: We provide a fully trained team of technicians and lab directors to operate your lab smoothly.",
            ],
            listItemBoldText: [
              "Fully Equipped Lab Spaces",
              "Regulatory Compliance",
              "Trained Staff",
            ],
          },
        ]}
      />

      <FeatureCard
        sectionTitle="Why In-House Toxicology Works Best"
        sectionDescription="Toxicology labs support various healthcare providers. This includes primary care doctors and addiction centers. It improved patient outcomes and made care more effective."
        highlightText="Works Best"
        features={featuresCardData}
      />

      <FeatureImageContent
        heading="Take the First Step"
        description="Transform your practice with MITS’s extensive toxicology solutions. We provide everything you need to succeed. Our lab spaces are ready to use. The staff is fully trained in advanced technology. In-house testing creates a new revenue flow."
        buttonLabel="Get Started"
        buttonUrl="/contact-us"
        imageAlt="Take the First Step"
      />

      <NumbersFlow
        eyebrow="Toxicology Lab Process"
        heading="Our Process"
        highlights={["Process"]}
        intro="Our proven process simplifies toxicology laboratory setup, validation, compliance, and ongoing operations to deliver reliable and efficient lab services."
        steps={collectionSteps}
      />

      <ImageTextSection
        image={section2Image}
        imageAlt="Tools & Consumables We Provide"
        imagePosition="right"
        title="Tools & Consumables We Provide"
        highlightWords="Provide"
        subSections={[
          {
            heading: "Advanced Toxicology Instruments:",
            description: "High-precision analyzers for efficient testing.",
          },
          {
            heading: "Consumables & Reagents:",
            description:
              "Reliable supply of calibrators, controls, and other essentials for uninterrupted operations.",
          },
          {
            heading: "Specimen Validity Testing:",
            description: "Ensure sample integrity for accurate results.",
          },
        ]}
      />

      <FeatureFlow
        heading="Who Benefits from Toxicology Labs ?"
        highlights={["Toxicology", "Labs", "?"]}
        paragraph="Toxicology labs help many healthcare providers. These include primary care physicians, who need quick test results, and addiction recovery facilities, which use drug tests to guide treatment. This leads to better patient outcomes and more effective care."
        steps={stepper}
      />

      <ImageTextSection
        image={section3Image}
        imageAlt="Benefits of Partnering"
        imagePosition="left"
        title="Benefits of Partnering"
        description="MITSI is an excellent partner for you, with many benefits. There is no need for upfront payments. Our unique price model has got you! We also provide personalized solutions that fit your needs. This helps the technology blend smoothly into your work. Plus, we keep an eye on standards and accuracy. So, rest assured, your test results are top-notch and completely compliant."
        highlightWords="Partnering"
      />
    </>
  );
}
